import mainApi from "../api.js";
import { getCachedScript } from "../scriptCache.js";

function getMetadaAdobe(data, prompt) {
  const nameTemplate = data.nameTemplate;
  const category = data.selectedCategory || "";
  const path = data.path;
  const names = data.names.map((item) => item.name);
  const nameZips = data.names.map((item) => item.nameZip);
  const message = data.message;

  mainApi
    .getOpenAi(prompt)
    .then((answer) => {
      try {
        let keywordsArray = answer.response;

        try {
          // Попробуем распарсить, если это строка
          if (typeof keywordsArray === "string") {
            keywordsArray = JSON.parse(keywordsArray);
          }

          // Проверим, что это массив массивов
          if (Array.isArray(keywordsArray) && Array.isArray(keywordsArray[0])) {
          } else {
          }
        } catch (err) {
          console.error("Ошибка при парсинге:", err);
          alert("Ошибка при парсинге: " + err.message);
        }

        const rows = [];

        for (let i = 0; i < names.length; i++) {
          const filename = nameZips[i] + ".zip";

          // Преобразуем имя в читаемый Title:
          // - Удаляем лишние пробелы
          // - Вставляем пробелы перед заглавными буквами и цифрами
          // - Очищаем результат
          const rawTitle = names[i].replace(/\s+/g, "");
          const title = rawTitle
            .replace(/([a-z])([A-Z])/g, "$1 $2") // camelCase → camel Case
            .replace(/([A-Za-z])(\d+)/g, "$1 $2") // abc123 → abc 123
            .replace(/(\d+)([A-Za-z])/g, "$1 $2") // 123abc → 123 abc
            .trim();

          // Берём ключевые слова по индексу
          let keywordsList = keywordsArray[i];
          if (!Array.isArray(keywordsList)) {
            // fallback — если по индексу ничего нет, возьми первые
            keywordsList = keywordsArray[0];
          }
          const keywords = keywordsList.join(", ");

          rows.push(`"${filename}","${title}","${category}","${keywords}"`);
        }

        const header = `"Filename","Title","Template Category","Keywords"`;
        const csvContent = [header, ...rows].join("\n");

        const saveResult = window.cep.fs.writeFile(
          `${path}/${nameTemplate.toLowerCase()}-metadata.csv`,
          csvContent,
          window.cep.encoding.UTF8,
        );

        if (saveResult.err === 0) {
          console.log("Файл успешно сохранен:", `${path}/metadata.csv`);
          window.jsx.evalScript("alert('Metadata Сreated Successfully')");
        } else {
          alert("Ошибка при сохранении CSV файла: " + saveResult.err);
        }
      } catch (err) {
        console.error("Ошибка обработки ключевых слов:", err);
        alert("Ошибка обработки ключевых слов.");
      }
    })
    .catch((error) => {
      console.error("Ошибка при запросе к OpenAI:", error);
      alert("Ошибка при запросе к OpenAI.");
    });
}

export default getMetadaAdobe;
